import React from 'react';
import propTypes from 'prop-types';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { Button, Icon, Modal } from 'semantic-ui-react';

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
);

const CHART_METRICS = [
	{ key: 'tsc', label: 'TSC', color: 'rgb(54, 162, 235)' },
	{ key: 'drc', label: 'DRC', color: 'rgb(255, 99, 132)' },
	{ key: 'nh3', label: 'NH3', color: 'rgb(75, 192, 192)' },
	{ key: 'mg', label: 'MG', color: 'rgb(255, 159, 64)' },
	{ key: 'vfa', label: 'VFA', color: 'rgb(153, 102, 255)' },
	{ key: 'dilution', label: '%DILUTION', color: 'rgb(255, 205, 86)' },
];

const CHART_OPTIONS = {
	responsive: true,
	maintainAspectRatio: false,
	plugins: {
		legend: {
			position: 'top',
		},
	},
	scales: {
		x: {
			title: {
				display: true,
				text: 'Date',
			},
		},
		y: {
			title: {
				display: true,
				text: 'Value',
			},
		},
	},
};

export default function PondStatisticChartModal(props) {
	const chartRef = React.useRef(null);

	const chartData = React.useMemo(() => ({
		labels: props.data.map(item => item.time),
		datasets: CHART_METRICS
			.filter(metric => props.chemicalCheck.includes(metric.key))
			.map(metric => ({
				label: metric.label,
				data: props.data.map(item => Number(item[metric.key])),
				borderColor: metric.color,
				backgroundColor: metric.color,
				tension: 0.1,
			})),
	}), [props.data, props.chemicalCheck]);

	const downloadChart = () => {
		const chart = chartRef.current;
		if (!chart) return;

		const {canvas} = chart;
		const exportCanvas = document.createElement('canvas');
		exportCanvas.width = canvas.width;
		exportCanvas.height = canvas.height;
		const ctx = exportCanvas.getContext('2d');
		ctx.fillStyle = '#ffffff';
		ctx.fillRect(0, 0, exportCanvas.width, exportCanvas.height);
		ctx.drawImage(canvas, 0, 0);

		const link = document.createElement('a');
		link.download = 'pond-statistic-chart.jpeg';
		link.href = exportCanvas.toDataURL('image/jpeg', 1);
		link.click();
	};

	return (
		<Modal
			open={props.open}
			onClose={props.onClose}
			size="large">
			<Modal.Header>Chart</Modal.Header>
			<Modal.Content>
				<div style={{height: 400}}>
					{props.open &&
						<Line ref={chartRef} data={chartData} options={CHART_OPTIONS}/>
					}
				</div>
			</Modal.Content>
			<Modal.Actions>
				<Button onClick={props.onClose}>Close</Button>
				<Button primary onClick={downloadChart}>
					<Icon name="download"/>
					Download JPEG
				</Button>
			</Modal.Actions>
		</Modal>
	);
}

PondStatisticChartModal.defaultProps = {
	open: false,
	onClose: () => {},
	data: [],
	chemicalCheck: ['tsc', 'drc', 'mg', 'nh3', 'vfa', 'dilution'],
};

PondStatisticChartModal.propTypes = {
	open: propTypes.bool,
	onClose: propTypes.func,
	data: propTypes.array,
	chemicalCheck: propTypes.array,
};
